import { render } from "./DetailCategoryView.vue?vue&type=template&id=5faed544"
import script from "./DetailCategoryView.vue?vue&type=script&lang=js"
export * from "./DetailCategoryView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__